import React from 'react';
import moment from 'moment';
import { css } from 'glamor'
import RenderStatus from '../../../../../utils/Render.js'

let space = css({
  margin: '0 4px'
})

export default class AllAssetRow extends React.Component {
  renderBookingInfo() {
    return (
      <div className="small text-muted">
        <a role="button" className="apple-blue hover-apple-blue no-break" onClick={(e)=>{e.stopPropagation();this.props.self.toggleModalReasign(this.props.RowData)}}>Book now</a>
      </div>
    )
  }

  renderButtonBooking = (rowData) => {
    return (
      <button 
        className={(rowData.CanBook ? 'btn-badge btn-primary no-break' : 'no-break btn btn-default btn-badge-dis')} 
        onClick={(e)=>this.gotoDetailAsset(e, rowData)}
        disabled={!rowData.CanBook}
      >Book Now</button>
    )
  }

  gotoDetailAsset = (e, rowData) => {
    e.stopPropagation()
    this.props.self.toggleModalDetail(e, rowData)
  }
    
  render() {
    const {rowData} = this.props

    return (
      <tr onClick={((e)=>e.preventDefault, (e)=>this.gotoDetailAsset(e, rowData))}>
        <td>
          <div><strong role="button" className="spaceR">{rowData.Name}</strong>(<span>{rowData.Description}</span>)</div>
          <div className="small text-muted">
            Created:<span {...space}>{moment(rowData.CreatedTime).format('ll')}</span>
            &middot;
            From Now:<span {...space}>{moment(rowData.CreatedTime).fromNow()}</span>
          </div>
        </td>
        <td>
          <span>{rowData.Type}</span>
        </td>
        <td>
          <span>{rowData.SerialNumber}</span>
        </td>
        <td>
          <span>{rowData.Owner}</span>
        </td>
        <td>
          <span>{rowData.Site}</span>
        </td>
        <td>
          <span>{rowData.Location}</span>
        </td>
        <td>
          <span>{rowData.Status}</span>
        </td>
        <td className="text-center">
          {this.renderButtonBooking(rowData)}
        </td>
        <td className="text-center">
          {RenderStatus.MaintenaceStatus(rowData, this.props)}
        </td>
      </tr>
    );
  }
}


// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/component/AllAsset/AllAssetRow.js